import React from "react";
import "./styles.css";
import {
  Form,
  Select,
  Input,
  InputNumber,
  Radio,
  Button,
  DatePicker,
} from "antd";
const FormItem = Form.Item;
const Option = Select.Option;

const RadioGroup = Radio.Group;

const VentasForm = () => {
  return (
    <div className="ventaform">
      <Form>
        <FormItem label="Ventas de Otra Categoria">
          <span className="ant-form-text">Ventas Extra</span>
        </FormItem>
        <span className="fit">Total:</span>
        <FormItem>
          <InputNumber
            min={1}
            max={20000000}
            placeholder="$"
            style={{ width: 150 }}
          />

          <span className="ant-form-text"> Pesos</span>
        </FormItem>
        <FormItem hasFeedback style={{ width: 400 }}>
          <span className="billetera">Billetera:</span>

          <Select placeholder="Caja">
            <Option value="cajafabrica">Caja Fabrica</Option>
            <Option value="beta">Beta</Option>
            <Option value="ale">Ale</Option>
          </Select>
        </FormItem>

        <FormItem>
          <span>Notas:</span>
          <Input placeholder="Venta de que item" />
        </FormItem>

        {/* 
        <FormItem>
          <RadioGroup>
            <Radio value="hoy">Hoy</Radio>
            <Radio value="ayer">Ayer</Radio>
            <Radio value="otro">Otro</Radio>
          </RadioGroup>
        </FormItem> */}

        <span className="fit">Fecha:</span>

        <FormItem>
          <DatePicker disableFuture />
        </FormItem>

        {/* <FormItem {...formItemLayout} label="Dragger">
        <div className="dropbox">
          {getFieldDecorator("dragger", {
            valuePropName: "fileList",
            getValueFromEvent: this.normFile,
          })(
            <Upload.Dragger name="files" action="/upload.do">
              <p className="ant-upload-drag-icon"></p>
              <p className="ant-upload-text">
                Click or drag file to this area to upload
              </p>
              <p className="ant-upload-hint">
                Support for a single or bulk upload. Strictly prohibit from
                uploading company data or other band files
              </p>
            </Upload.Dragger>
          )}
        </div>
      </FormItem> */}

        <FormItem wrapperCol={{ span: 12, offset: 6 }}>
          <Button type="primary" htmlType="submit">
            Agregar
          </Button>
        </FormItem>
      </Form>
    </div>
  );
};
export default VentasForm;
